import * as React from 'react';
/**
 * List component
 *
 * @see **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/list.md
 *
 */
export default function List(_a) {
    var _b = _a.mode, mode = _b === void 0 ? 'default' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children;
    return (React.createElement("ul", { className: "madonna-list mdc-list " + (mode !== 'default' ? 'mdc-list--two-line' : '') + " " + className }, children));
}
//# sourceMappingURL=List.js.map